<template>
    <div class="container-fluid">
        <div class="row justify-content-center">
            <div class="col-12">
                <div class="header mt-md-5">
                    <div class="header-body">
                        <div class="row align-items-center">
                            <div class="col">
                                <h6 class="header-pretitle">{{$t('Store')}}</h6>
                                <h1 class="header-title">{{$t('Products')}}</h1>
                            </div>
                            <div class="col-auto">
                                <button
                                    @click="openModal({id:'productFormModal', model:productDefaults})"
                                    class="btn btn-primary"
                                >{{$t('Add product')}}</button>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Card -->
                <div class="row" v-if="1>2">
                    <div class="col-4">
                        <!-- Card -->
                        <div class="card">
                            <div class="card-body">
                                <div class="row align-items-center">
                                    <div class="col">
                                        <h6 class="card-title text-uppercase text-muted mb-2">{{$t('Total')}}</h6>
                                        <span class="h2 mb-0">{{ totalRows }}</span>
                                    </div>
                                    <div class="col-auto">
                                        <span class="h2 fe fe-package text-muted mb-0"></span>
                                    </div>
                                </div>
                                <!-- / .row -->
                            </div>
                        </div>
                    </div>

                    <div class="col-4">
                        <div class="card">
                            <div class="card-body p-0">
                                <Doughnut :chartData="chartData" scheme="HueCircle19" :styles="{height:'65px'}"></Doughnut>
                            </div>
                        </div>
                    </div>
                    <div class="col-4">
                        <div class="card">
                            <div class="card-body p-3">
                                <Doughnut :chartData="brandData" scheme="HueCircle19" :styles="{height:'65px'}"></Doughnut>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card" data-toggle="lists">
                    <div class="card-header">
                        <div class="row align-items-center">
                            <div class="col">
                                <!-- Search -->
                                <div class="row align-items-center">
                                    <div class="col-auto pr-0">
                                        <span class="fe fe-x text-muted" v-if="query" @click="query=null"></span>
                                        <span class="fe fe-search text-muted" v-else></span>
                                    </div>
                                    <div class="col">
                                        <input
                                            type="search"
                                            v-model="query"
                                            class="form-control form-control-flush search no-glow"
                                            :placeholder="$t('Search')"
                                        />
                                    </div>
                                </div>
                            </div>

                            <!-- brand filter -->
                            <div class="d-none d-xl-block col-auto">
                                <div class="dropdown">
                                    <b-button-group>
                                        <button
                                            class="btn btn-white"
                                            @click="brandsQuery=[];"
                                            v-if="brandsQuery.length>0"
                                        >
                                            <span class="fe fe-x"></span>
                                        </button>
                                        <b-dropdown variant="white" right :text="$t('Brands')">
                                            <div class="pt-1 pb-1 pl-3 pr-3">
                                                <b-form-checkbox
                                                    v-for="(brand, index) in brands"
                                                    :key="index"
                                                    v-model="brandsQuery"
                                                    :value="brand._id"
                                                    class="mb-3"
                                                >{{ brand.label }}</b-form-checkbox>
                                            </div>
                                        </b-dropdown>
                                    </b-button-group>
                                </div>
                            </div>

                            <!-- category filter -->
                            <div class="d-none d-xl-block col-auto">
                                <div class="dropdown">
                                    <b-button-group>
                                        <button class="btn btn-white" @click="categoriesQuery=[];" v-if="categoriesQuery.length>0">
                                            <span class="fe fe-x"></span>
                                        </button>
                                        <b-dropdown variant="white" right :text="$t('Categories')">
                                            <div class="pt-1 pb-1 pl-3 pr-3">
                                                <b-form-checkbox
                                                    v-for="(category, index) in categories"
                                                    :key="index"
                                                    v-model="categoriesQuery"
                                                    :value="category._id"
                                                    class="mb-3"
                                                >{{ category.label }}</b-form-checkbox>
                                            </div>
                                        </b-dropdown>
                                    </b-button-group>
                                </div>
                            </div>

                            <!-- filter button -->
                            <div class="col-auto d-xl-none">
                                <b-button @click="openModal({id:'productsFilterModal'})" variant="white" size="md">
                                    <i class="fe fe-filter"></i>
                                </b-button>
                            </div>

                        </div>
                        <!-- / .row -->
                    </div>

                    <simple-table
                        :data="items"
                        :onSort="setSort"
                        :loading="areProductsLoading"
                        :edit="edit"
                        :hideDeleteButton="true"
                        :deleteItem="deleteItem"
                        :columns="columns"
                        :sort="sort"
                    ></simple-table>
                </div>
                <div class="mt-3 text-center" v-if="totalRows > perPage">
                    <b-pagination :total-rows="totalRows" v-model="currentPage" :per-page="perPage" />
                </div>
            </div>
        </div>

        <mobile-filters-modal id="productsFilterModal">
            <!-- brand filter -->
            <div class="col-12 mb-3">
                <div class="dropdown">
                    <b-button-group>
                        <button
                            class="btn btn-white"
                            @click="brandsQuery=[];"
                            v-if="brandsQuery.length>0"
                        >
                            <span class="fe fe-x"></span>
                        </button>
                        <b-dropdown variant="white" right :text="$t('Brands')">
                            <div class="pt-1 pb-1 pl-3 pr-3">
                                <b-form-checkbox
                                    v-for="(brand, index) in brands"
                                    :key="index"
                                    v-model="brandsQuery"
                                    :value="brand._id"
                                    class="mb-3"
                                >{{ brand.label }}</b-form-checkbox>
                            </div>
                        </b-dropdown>
                    </b-button-group>
                </div>
            </div>

            <!-- category filter -->
            <div class="col-12 mb-3">
                <div class="dropdown">
                    <b-button-group>
                        <button class="btn btn-white" @click="categoriesQuery=[];" v-if="categoriesQuery.length>0">
                            <span class="fe fe-x"></span>
                        </button>
                        <b-dropdown variant="white" right :text="$t('Categories')">
                            <div class="pt-1 pb-1 pl-3 pr-3">
                                <b-form-checkbox
                                    v-for="(category, index) in categories"
                                    :key="index"
                                    v-model="categoriesQuery"
                                    :value="category._id"
                                    class="mb-3"
                                >{{ category.label }}</b-form-checkbox>
                            </div>
                        </b-dropdown>
                    </b-button-group>
                </div>
            </div>
        </mobile-filters-modal>

        <product-form-modal id="productFormModal" :data="model"></product-form-modal>
    </div>
</template>

<script>
    import ProductFormModal from './ProductFormModal.vue'
    import SimpleTable from '@/components/SimpleTable.vue'
    import {modalMixins} from '@/mixins/modal.js'
    import {mapActions, mapGetters, mapState} from 'vuex';
    import debounce from 'lodash/debounce';
    import currency from '@/filters/currency.js';
    import Doughnut from '@/components/Charts/Doughnut.vue'
    import mobileFiltersModal from "@/components/mobileFiltersModal";


    export default {
    mixins: [modalMixins],
    components: {
        Doughnut,
        SimpleTable,
        ProductFormModal,
        mobileFiltersModal
    },
    data() {
        return {
            hideForm: false,
            isMobileFilter: false,
            chartRaw: [],
            brandChartRaw: [],
            productDefaults: {
                avatar_id: null,
                avatar: {},
                enableStock: true,
                price: {},
                enablePricing: true,
                enableSupply: true,
                stock: {},
                supplies: [],

            },
            date: null,
            query: null,
            categoriesQuery: [],
            brandsQuery: [],
            params: {
                query: {
                    $limit: 10000,
                    deleted: false,
                    // $skip: (this.currentPage - 1) * this.perPage,
                    inWaitlist: { $ne: true },
                    $sort: 'createdAt',
                    // $order: -1
                }
            },
            currentPage: 1,
            perPage: 100,
            totalRows: 0,
            sort: 'createdAt',
            order: -1,
            model: {},
            errors: {},
            columns: [
                {
                    label: '',
                    width: '20px',
                    field(item) {
                        let iconClass = 'text-success';
                        let percentage;
                        percentage = Math.ceil(((item.stock.quantity - item.minimum) * 100) / item.stock.quantity);
                        if (percentage <= 50) {
                            iconClass = 'text-warning';
                        }
                        if (percentage <= 30) {
                            iconClass = 'text-danger';
                        }
                        return `<h1 class="${iconClass}">●</h1>`;
                    }
                },
                {
                    label: 'Image',
                    name: 'avatar',
                    image: true,
                    width: 50,
                    field: (item) => {
                        if (item.avatar && item.avatar.preview) {
                            return item.avatar.preview;
                        } else return false;
                    }
                },
                {
                    label: 'Product name',
                    name: 'label',
                    sortable: true,
                    link(item) {
                        return { name: 'materials.product', params: { productId: item._id } };
                    },
                    subtitle: (item) => {
                        let subtitle = '';
                        if (item.category)
                            subtitle += item.category.label;
                        if (item.brand)
                            subtitle += '  ' + item.brand.label;

                        return subtitle;

                    },

                },
                {
                    label: 'SKU',
                    name: 'sku',
                    sortable: true,
                    subtitle: (item) => {
                        return item.barcode;
                    },
                },
                {
                    label: 'Price',
                    name: 'price',
                    // money: true,

                    field: (item) => {
                        // return item.supply;
                        if (item.price)
                            return currency(item.price.retailPrice, this.$settings.currency.text, 0, { spaceBetweenAmountAndSymbol: ' ', symbolOnLeft: false });

                    },
                    subtitle: (item) => {
                        if (item.price)
                            return currency(item.price.specialPrice, this.$settings.currency.text, 0, { spaceBetweenAmountAndSymbol: ' ', symbolOnLeft: false });

                    },
                },
                {
                    label: 'Stock',
                    name: 'stock',

                    field: (item) => {
                        if (item.stock) {
                            let textClass = 'text-muted';

                            let measurement = (item.measurement) ? '' + this.$t(item.measurement) : '';

                            if (item.stock.quantity) {
                                return item.stock.quantity + `<span class="${textClass}">/` + item.stock.initialQuantity + '</span> ' + measurement;
                            } else {
                                return 'N/A'
                            }

                        }
                    },
                },
                {
                    label: 'Minimum',
                    name: 'minimum',
                    field: (item) => {
                        let measurement = (item.measurement) ? '' + this.$t(item.measurement) : '';
                        return (item.minimum) ? item.minimum + ' ' + measurement : 'N/A';
                    }
                }

            ],
        };
    },
    computed: {
        ...mapState('products', { areProductsLoading: 'isFindPending' }),
        ...mapGetters('products', {
            findProductsInStore: 'find'
        }),
        ...mapGetters('categories', {
            findCategoriesInStore: 'find',
            getCategoryById: 'get'
        }),
        ...mapGetters('brands', {
            findBrandsInStore: 'find',
            getBrandById: 'get'
        }),
        items() {
            let items = this.findProductsInStore(this.params).data;

            items.map(item => {
                item.category = this.getCategoryById(item.categoryId);
                item.brand = this.getBrandById(item.brandId);
                if (!item.price) item.price = {};
                if (!item.stock) item.stock = {};
            })
            return items;
        },
        categories() {
            return this.findCategoriesInStore().data;
        },
        brands() {
            return this.findBrandsInStore().data;
        },
        suppliers() {
            return this.findSuplliersInStore().data;
        },
        brandData: {
            get() {
                return this.brandChartRaw;
            },
            set(values) {
                values.map(item => {
                    let brand = this.getBrandById(item._id);
                    if (!brand) return;
                    item._id = brand.label;

                });
                this.brandChartRaw = values;
            }
        },
        chartData: {
            get() {
                return this.chartRaw;
            },
            set(values) {
                values.map(item => {
                    // item._id = this.getCategoryById(item._id).label;
                });
                this.chartRaw = values;
            }
        }
    },
    watch: {
        query: debounce(function (newVal) {
            if (newVal) {
                // params.query.$search = this.query;
                this.params.query.$or = [
                    { label: { $regex: this.query, $options: "i" } },
                ];
            } else {
                delete this.params.query.$or;
            }
            this.fetchItems();
        }, 400),
        currentPage: debounce(function (newVal) {

        }, 400),
        categoriesQuery: debounce(function (newVal) {
            if (newVal.length > 0) {
                this.params.query.categoryId = { $in: newVal };
            } else {
                delete this.params.query.categoryId;
            }
            this.fetchItems();
        }, 400),

        brandsQuery: debounce(function (newVal) {
            if (newVal.length > 0) {
                this.params.query.brandId = { $in: newVal };
            } else {
                delete this.params.query.brandId;
            }
            this.fetchItems();
        }, 400),

    },
    created() {

        Promise.all([this.fetchBrands({ query: { $limit: 1000 } }), this.fetchCategories({ query: { $limit: 1000 } })]).then(items => {
            this.fetchSupliers({ query: { $limit: 10000 } });
            this.fetchItems();
        });

    },
    methods: {
        ...mapActions('products', ['find', 'remove', 'create', 'patch']),
        ...mapActions('categories', { fetchCategories: 'find' }),
        ...mapActions('brands', { fetchBrands: 'find' }),
        ...mapActions('suppliers', { fetchSupliers: 'find' }),

        setSort(field, order) {
            this.sort = field;
            this.order = order;
            this.fetchItems();
        },
        edit(item) {
            this.openModal({ id: 'productFormModal', model: item })

        },
        deleteItem(item) {
            this.remove(item._id).then(result => {
                this.$toasted.global.success({
                    message: 'Product has been removed'
                });
            });
        },
        fetchItems() {

            this.find(this.params).then(result => {
                this.chartData = result.meta;
                this.brandData = result.brandChart;
                this.totalRows = result.total;
            });
        },
    }
}
</script>
